import { Menu } from 'antd';
import type { MenuProps } from 'antd';

export interface DMenuProps extends MenuProps {}

export const DarwinMenu = (props: DMenuProps) => {
  return <Menu {...props} />;
};
